import {
  Alert,
  AppBar,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  IconButton,
  LinearProgress,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Pagination,
  Popover,
  Snackbar,
  Select,
  Stack,
  Stepper,
  Step,
  StepLabel,
  Switch,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup as MuiToggleButtonGroup,
  Toolbar,
  Tooltip,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

const ButtonGroup = ({ children }) => {
  return (
    <Box display="flex" flexWrap="wrap" justifyContent="flex-end" gap={1}>
      {children}
    </Box>
  );
};

export {
  Alert,
  AppBar,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  FormControlLabel,
  Grid,
  Grid as Grid2,
  InputAdornment,
  InputLabel,
  IconButton,
  LinearProgress,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Menu,
  MenuItem,
  Modal,
  Pagination,
  Popover,
  Select,
  Snackbar,
  Stack,
  Stepper,
  Step,
  StepLabel,
  Switch,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tab,
  Tabs,
  ToggleButton,
  MuiToggleButtonGroup,
  Tooltip,
  Toolbar,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
};
